import { put, take } from 'redux-saga/effects';

import { virtualVisitActions } from '../virtual-visit';
import { URGENT_VISIT_TYPE_CODE } from '../../../constants';
import * as changeStatus from '../requests/status-change-req';
import { appointmentDetailsActions } from '../appointment-details';
import { hideLoaderInPopup, showLoaderInPopup } from '../../ui/popup';
import * as appointmentDetails from '../../appointmnents/appointment-details-req';
import * as changeUrgentVisitStatus from '../requests/status-urgent-visit-change-req';

function* handleChangeRequest(request, payload) {
  yield put(request.actions.send(payload));
  const { payload: result } = yield take(request.consts.SUCCEED);
  return { result };
}

function* defineChangeRequestByCode({ code, ...payload }) {
  switch (code) {
    case URGENT_VISIT_TYPE_CODE: {
      yield put(virtualVisitActions.reset());
      return yield handleChangeRequest(changeUrgentVisitStatus, payload);
    }
    default:
      return yield handleChangeRequest(changeStatus, payload);
  }
}

export function* declineVirtualVisit({ id, event, reason, appointment }) {
  const appointmentId = appointment.id;
  const { code } = appointment.visitType;

  yield put(showLoaderInPopup());

  const { result } = yield defineChangeRequestByCode({
    id,
    code,
    event,
    reason,
    appointmentId,
  });

  yield put(hideLoaderInPopup());

  yield put(appointmentDetails.actions.succeed(result));

  yield put(
    appointmentDetailsActions.sliceUpcomingAppointment({
      ...result,
      userId: id,
    }),
  );
}



// WEBPACK FOOTER //
// ./src/redux/healthboard/sagas/decline-virtual-visit-saga.js